module.exports = __webpack_public_path__ + "images/fastmoney-bf6aefd5.png";